import Vue from 'vue'
import moment from "moment";

import "moment/locale/ru";
import "moment/locale/az";

Vue.filter("formatDate", function (value) {
  moment.locale(window.lang);
  if (value) {
      return moment(String(value)).format("MMM D");
  }
});
Vue.filter("formatNumber", function (phoneNumber) {
  if (!phoneNumber) return;
  return phoneNumber.startsWith('00994')
  ? phoneNumber.replace('00994', '')
  : phoneNumber;
});

Vue.filter("formatMultipleDate", function (dates) {
  moment.locale(window.lang);
  //group array by months
  var groups = _.groupBy(dates, function (date) {
      return moment(date).month();
  });

  //format string from months and days
  var result = "";
  var index = 1;
  Object.keys(groups).forEach(function(key) {
      //loop throw days and add them to result
      groups[key].forEach((date, index) => {
          if(index + 1 != groups[key].length){
              result += moment(String(date)).format("DD") + ', ';
          }else{
              result += moment(String(date)).format("DD MMM");
          }
      });

      if(Object.keys(groups).length > 1 && index != Object.keys(groups).length){
          result += ', ';
      }

      index++;
      
  });
  return result;
  // if (value) {
  //     return moment(String(value)).format("DD MMM");
  // }

});


Vue.filter("formatTime", function (value) {
  moment.locale(window.lang);
  if (value) {
      return moment(String(value), "HH:mm:ss").format("HH:mm");
  }
});
Vue.filter("formatString", function (string, length) {
  if (!length) return string;
  return string.length > length ? string.slice(0, length - 4) + '...' : string;
});

Vue.filter("formatDateTime", function (value) {
  moment.locale(window.lang);
  if (value) {
      return moment(String(value)).format("YYYY-MM-DD HH:mm:ss");
  }
});

//Mon 1st Jun
Vue.filter("formatDayDate", function (value) {
  moment.locale("en");
  var key = moment(String(value)).format("ddd");
  var day = _.get(window.trans, key, key);
  moment.locale(window.lang);
  if (value) {
      return day + " " + moment(String(value)).format("D MMM");
  }
});